import React from 'react'
import { colors } from '@fs/zion-ui'
import { kebabCase } from 'lodash-es'

import SocialShareImage from './SocialShareImage'
import { LeadSectionSurname } from '../../../../../components/section-templates'
import ShareableImage from '../../../../../components/ShareableImage/ShareableImage'
import useShareableImage from '../../../../../components/ShareableImage/useShareableImage'
import bgMobilePattern from '../images/lead-bg-pattern-mobile.webp'
import bgPattern from '../images/lead-bg-pattern.webp'
import imageMobile1 from '../images/mobile-surname-1.webp'
import imageMobile2 from '../images/mobile-surname-2.webp'
import imageMobile3 from '../images/mobile-surname-3.webp'
import imageMobile4 from '../images/mobile-surname-4.webp'
import socialShareImage from '../images/ph-surname-social.jpg'
import image1 from '../images/surname-1.webp'
import image2 from '../images/surname-2.webp'
import image3 from '../images/surname-3.webp'
import image4 from '../images/surname-4.webp'

const images = [image1, image2, image3, image4]
const mobileImages = [imageMobile1, imageMobile2, imageMobile3, imageMobile4]

export default function LeadSection({ surname, recordCount }) {
  const shareable = useShareableImage({
    width: 786,
    height: 597,
    generateOnLoad: false,
    name: kebabCase(surname),
    scale: 1.4,
  })

  return (
    <>
      <LeadSectionSurname
        color={colors.blue03}
        socialShareProps={{
          sharable: {
            url: globalThis?.location?.href || '',
            subject: `Check out my surname: ${surname}`,
            message: `My Surname is Found ${recordCount?.toLocaleString()} Times in FamilySearch Records!`,
            imageUrl: socialShareImage,
          },
          analytics: {
            link_name: `button: philippines-surname: ${kebabCase(surname)}: social: click`,
            link_page: globalThis?.location?.href || '',
            link_app: 'APAC',
          },
          onDownloadClick: async () => {
            await shareable.generateImage()
            await shareable.downloadImage()
          },
        }}
        surname={surname}
        images={images}
        mobileImages={mobileImages}
        bgImage={bgPattern}
        bgMobileImage={bgMobilePattern}
      />
      <ShareableImage {...shareable}>
        <SocialShareImage surname={surname} recordCount={recordCount} />
      </ShareableImage>
    </>
  )
}
